<template>
  <div class="search-input">
    <i class="el-icon-search" />
    <input type="text" :value="value" @input="$emit('input', $event.target.value)" placeholder="Search"/>
  </div>
</template>

<script>
export default {
  name: 'SearchInput',
  props: {
    value: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .search-input {
    position: relative;
  }

  i {
    position: absolute;
    left: 10px;
    color: $text-light;
    top: 50%;
    transform: translateY(-50%);
  }

  input {
    width: 100%;
    border: none;
    height: 38px;
    padding-left: 35px;
    padding-right: 10px;
    font-size: 12px;
    box-sizing: border-box;

    box-shadow: 0px 12px 18px -9px rgba($text-light,0.1);

    @include breakpoint (xs) {
      height: 60px;
    }


    &:focus {
      outline: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/organizations/organization/lists/SearchInput.vue